import { get, patch, post, put } from "./axios";
import { encrypt } from "@/util/rsa";

//登录
export function userLogin(client, data) {
  return post(`/open/auth/login/${client}`, data);
}

//登录
export function resetPasswd(data) {
  return post(`/open/auth/reset-password`, data);
}

// 起飞前接口

/*
* 获取mqtt推送订阅名称
* */
export function userCurrent() {
  return get("/user/current");
}

/**
 * 当前登录用户修改密码
 * @param passwordOld {string} 原密码
 * @param passwordNew  {string} 新密码
 * @return {Promise<Result>}
 */
export function changePassword(passwordOld, passwordNew) {
  return post('/user/change-password', {
    passwordOld: encrypt(passwordOld),
    passwordNew: encrypt(passwordNew)
  })
}

export function loginOut() {
  return post("/logout");
}

/*
* 获取起飞前故障决策处理记录
* params data
* */
export function planeErrorRecord(data) {
  return get(`/plane-error-record-handle/page/${data.number}/${data.limit}`);
}

/*
* 获取故障决策历史记录
* */
export function planeErrorRecordHistory(pager, data) {
  return get(`/plane-error-record/page/user/${pager.number}/${pager.limit}`, data);
}

/*
* 故障详情
* */
export function planeErrorDetail(data) {
  return get(`/plane-error-record/${data.id}`);
}

/**
 * 航班列表
 * @param current
 * @param size
 * @param param
 * @returns {Promise<unknown>}
 */
export function pageFltPlan(current, size, param) {
  return get(`/parse-plan/pageVO/${current}/${size}`, param);
}

/**
 * 即将起飞的航班
 */
export function pageParsePlanAboutToVO() {
  return get("/parse-plan/page/ParsePlanAboutToVO");
}

/**
 * 根据id查询故障处理结果
 * @param id
 * @returns {Promise | Promise<unknown>}
 */
export function errorHandleById(id) {
  return get(`/plane-error-record-handle/${id}`);
}

/**
 * 新增起飞前故障决策记录
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function addErrorRecordHandle(data) {
  return post("/plane-error-record-handle", data);
}

/**
 *soc同意系统决策 起飞前
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function socAgree(id) {
  return patch(`/plane-error-record/done/${id}`);
}

/**
 *soc同意系统决策 起飞前
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export function socSubmit(id, data) {
  return patch(`/plane-error-record/done-soc/${id}`, data);
}

/*
* 获取故障决策pageSoc
* */
export function planeRiskRecord(pager) {
  return get(`/plane-risk-record/pageSoc/${pager.number}/${pager.limit}`);
}

/*
* 获取故障决策历史记录
* */
export function planeRiskRecordHistory(pager, param) {
  return get(`/plane-risk-record/pageHistory/${pager.number}/${pager.limit}`, param);
}

/**
 * 根据id查询飞行中故障
 * @param id
 * @returns {Promise | Promise<unknown>}
 */
export function planeRiskRecordById(id) {
  return get(`/plane-risk-record/${id}`);
}

/**
 * soc处理决策
 * @returns {Promise | Promise<unknown>}
 * @param data
 */
export function socReview(data) {
  return patch(`/plane-risk-record/socReview/${data.id}`, data);
}

/**
 * 根据recordId查询
 * @returns {Promise | Promise<unknown>}
 * @param data
 */
export function getHandle(data) {
  return get(`/plane-risk-record-handle/findByRecordId`, data);
}

/**
 * 修改handle信息
 * @returns {Promise | Promise<unknown>}
 * @param data
 */
export function updataHandle(data) {
  return put(`/plane-risk-record-handle/SOC/${data.dv}`, data);
}

/*
* 获取故障决策历史记录
* */
export function planeRiskRecordHandlePage(pager, param) {
  return get(`/plane-risk-record-handle/page/${pager.number}/${pager.limit}`, param);
}

/*
* 获取故障决策历史记录
* */
export function findVOHandle(param) {
  return get(`/plane-risk-record-handle/findVO/${param.id}`);
}


export function updataSimulatorHandle(data) {
  return put(`/plane-risk-record-handle/updateSimulator/${data.dv}`, data);
}

/*
* 机场
* */
export function airportPage(pager, param) {
  return get(`/airport/page/${pager.number}/${pager.limit}`, param);
}

/*
* 机场
* */
export function airportOptions() {
  return get("/airport/options");
}

/*
* 到达机场时间 重量
* */
export function toAirport(param) {
  return get(`/plane-risk-record/getAirportInfo`, param);
}
export function imageCode() {
  return get('/open/code');
}

export function sendMailCode(uuid, imageCode, email) {
  return post("/open/code/mail", { uuid, imageCode, email });
}



// WEBPACK FOOTER //
// ./src/api/api.js